// TODO: implement
export const getUrgencyLevels = (t) => [
    { id: "low", name: t.low, color: "#10b981", description: "Can wait" },
    {
      id: "normal",
      name: t.normal,
      color: "#3b82f6",
      description: "Standard processing",
    },
    {
      id: "high",
      name: t.high,
      color: "#f59e0b",
      description: "Needs attention",
    },
    {
      id: "urgent",
      name: t.urgent,
      color: "#ef4444",
      description: "Immediate action required",
    },
  ];